<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card no-shadow>
		<e-charts autoresize :options="pie" ref="pie" auto-resize />
	</vx-card>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import VueApexCharts from "vue-apexcharts";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
// Store Module
import moduleActivity from "@/store/activity/moduleActivity.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	components: {
		vSelect,
		Datepicker,
		VueApexCharts,
		ECharts,
	},
	props: {
		statistics: {
			type: Array,
			default: [],
		},
	},
	data() {
		return {
			pie: {
				tooltip: {
					trigger: "item",
					formatter: "{a} <br/>{b} : {c} ({d}%)",
				},
				legend: {
					orient: "vertical",
					left: "left",
					data: [
						this.$t("Schedule.Scheduled"),
						this.$t("Schedule.ReProgramming"),
						this.$t("Schedule.InProgress"),
						this.$t("Schedule.Finished"),
						this.$t("Schedule.Canceled"),
					],
				},
				series: [
					{
						name: "Eventos",
						type: "pie",
						radius: "55%",
						center: ["50%", "60%"],
						color: ["#3AAAFF", "#FFE15A", "#8448be", "#008805", "#FF0000"],
						data: [],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
					},
				],
			},
			previous: 0,
		};
	},
	computed: {
		title() {
			return `Total 5`;
		},
	},
	methods: {
		addDaysToDate(stringDate, dayNums) {
			// 1000 * 60 * 60 * 24 * 3
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		setInitSeries() {
			const findScheduled = this.statistics.find((e) => e.event_status_id === 2);
			const findReProgramming = this.statistics.find((e) => e.event_status_id === 3);
			const findInProgress = this.statistics.find((e) => e.event_status_id === 6);
			const findFinished = this.statistics.find((e) => e.event_status_id === 7);
			const findCanceled = this.statistics.find((e) => e.event_status_id === 8);
			this.pie.series[0].data = [
				{name: this.$t("Schedule.Scheduled"), value: findScheduled ? findScheduled.total_events : 0},
				{
					name: this.$t("Schedule.ReProgramming"),
					value: findReProgramming ? findReProgramming.total_events : 0,
				},
				{
					name: this.$t("Schedule.InProgress"),
					value: findInProgress ? findInProgress.total_events : 0,
				},
				{name: this.$t("Schedule.Finished"), value: findFinished ? findFinished.total_events : 0},
				{name: this.$t("Schedule.Canceled"), value: findCanceled ? findCanceled.total_events : 0},
			];
		},
		updateSeries(event_status_id) {
			const index = this.statusValidOptions.findIndex((statusOption) => statusOption.value === event_status_id);
			let dataIndex = index;
			let pie = this.$refs.pie;
			let dataLen = pie.options.series[0].data.length;
			pie.dispatchAction({
				type: "downplay",
				seriesIndex: 0,
				dataIndex: this.previous,
			});
			pie.dispatchAction({
				type: "highlight",
				seriesIndex: 0,
				dataIndex,
			});
			pie.dispatchAction({
				type: "showTip",
				seriesIndex: 0,
				dataIndex,
			});
			this.previous = dataIndex;
		},
	},
	mounted() {
		this.setInitSeries();
	},
	created() {
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		// Register Module VisitPoint Module
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
};
</script>

<style lang="scss">
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
</style>
